import { Statistic } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import useLotDetailsSupplementSupplyContext from "../../../../../../../hooks/useLotDetailsSupplementSupplyContext";
import { numberMask } from "../../../../../../../services/helpersMethodsService";

// import { Container } from './styles';

function CardAverageConsumeInMSSupplementSupplyDashboard() {
  const { averageAnimalSupplyInMS } = useLotDetailsSupplementSupplyContext();
  const { translation } = useSelector((state) => state.app);
  return (
    <Statistic
      title={
        translation.lot.production.details.supplementSupply.dashboards
          .averageConsumeMS
      }
      value={`${numberMask(averageAnimalSupplyInMS, false)} kg MS`}
      suffix={
        translation.lot.production.details.supplementSupply.dashboards
          .suffixCabDay
      }
    />
  );
}

export default CardAverageConsumeInMSSupplementSupplyDashboard;
